import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';
import { EntityList, PageHead } from '../../components/EntityList';
import AccountEditor from './AccountEditor';

function EditAccount() {
	const { id } = useParams();
	const navigate = useNavigate();

	return (
		<EntityList>
			<Helmet>
				<title>Editar Cuenta</title>
			</Helmet>
			<PageHead
				breadcrumb={[
					{ label: 'Inicio', to: '/AdminScreen' },
					{ label: 'Cuentas', to: '/AdminScreen/accounts' },
					{ label: 'Editar Cuenta' },
				]}
				title='Editar Cuenta'
				subtitle='Actualizá los datos principales de la cuenta.'
			/>
			<AccountEditor
				mode='edit'
				accountId={id}
				onCancel={() => navigate(`/AdminScreen/accounts/account/${id}`)}
				onSaved={(savedAccountId) => navigate(`/AdminScreen/accounts/account/${savedAccountId || id}`)}
				saveLabel='Guardar'
			/>
		</EntityList>
	);
}

export default EditAccount;
